export enum CryptoAccountReplenishStatus {
  PENDING = 'PENDING',
  DONE = 'DONE',
  TRANSFERED = 'TRANSFERED',
  FAILED = 'FAILED',
  CONFIRMED = 'CONFIRMED'
}

export enum CryptoAccountReplenishFailedReason {
  LESS_THEN_MIN_AMOUNT = 'LESS_THEN_MIN_AMOUNT'
}
